import { useRouter } from 'react-resource-router';

import { CLI_ROUTE_NAME, MCP_ROUTE_NAME } from '../../../routes';
import { type MicrositePage } from '../types';

/**
 * The `page` attribute for events fired from components shared by both
 * microsite routes, such as the navigation bar's feedback button.
 *
 * Router-derived rather than read from `window.location`, so it cannot drift:
 * `landingPath` in the attribution bag is re-read on every event, which makes
 * a deferred event stamp whichever path the visitor has since navigated to.
 */
export const useMicrositePage = (): MicrositePage => {
	const [{ route }] = useRouter();
	if (route?.name === CLI_ROUTE_NAME) {
		return 'cli';
	}
	if (route?.name === MCP_ROUTE_NAME) {
		return 'mcp';
	}
	return 'home';
};
